module.exports = __webpack_public_path__ + "media/swamp.55a6d94c.mp3";